// extracted by mini-css-extract-plugin
export default {"container":"BodyChrome_container__y5BQr"};